import { capitalize } from "lodash";

export { capitalize };

export const capitalizeEachWord = (string = "") => {
  return string.split(" ").map(capitalize).join(" ");
};
